import { FolderableType } from 'apps/folders/static/enums/folderable-type.enum';
import { SelectedFolderableService } from 'apps/folders/static/services/selected-folderable.service';
import * as i0 from "@angular/core";
export class SelectedTalkingPointsService extends SelectedFolderableService {
    constructor() {
        super(...arguments);
        this.RESOURCE_TYPE = FolderableType.TALKING_POINTS;
        this.ITEM_ID_SLICE_KEY = 'talkingPointId';
    }
}
SelectedTalkingPointsService.ɵfac = /*@__PURE__*/ (() => { let ɵSelectedTalkingPointsService_BaseFactory; return function SelectedTalkingPointsService_Factory(__ngFactoryType__) { return (ɵSelectedTalkingPointsService_BaseFactory || (ɵSelectedTalkingPointsService_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedTalkingPointsService)))(__ngFactoryType__ || SelectedTalkingPointsService); }; })();
SelectedTalkingPointsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedTalkingPointsService, factory: SelectedTalkingPointsService.ɵfac });
